/**
 * Tarifa de créditos de IA — espelho de `backend/app/services/ai/creditos.py`.
 *
 * A cota é em créditos, cobrados pelo que o advogado pede (nível da resposta,
 * tamanho do texto), nunca pelo custo do modelo (docs/PLANO_CREDITOS_IA.md). O
 * backend é quem debita; aqui só se mostra o número da revisão antes do clique, por
 * isso a regra dela tem de andar junto (`__tests__/creditosIa.test.tsx` fixa os
 * valores). A base do turno do chat não é espelhada: o menu de nível e o diálogo da
 * barra falam do consumo sem número, para a tarifa provisória poder mudar.
 */

const CARACTERES_POR_CREDITO = 5_000;

/** Revisão do editor: 1 crédito a cada 5 mil caracteres da peça, iniciados (mínimo 1). */
export function creditosDaRevisao(caracteres: number): number {
  return Math.max(Math.ceil(Math.max(caracteres, 0) / CARACTERES_POR_CREDITO), 1);
}

/** Créditos da maior revisão aceita (60 mil caracteres, `MAX_CARACTERES_REVISAO`). */
const CREDITOS_DA_MAIOR_REVISAO = 12;

/** Frase da dica do botão de revisão: o que ela vai debitar — ou, acima do teto, que
 *  ela não vai acontecer (o hook recusa antes do servidor, e nada é debitado). */
export function dicaCreditosDaRevisao(creditos: number): string {
  return creditos > CREDITOS_DA_MAIOR_REVISAO
    ? 'A peça passa de 60 mil caracteres, o limite de uma revisão.'
    : `Usa ${rotuloCreditos(creditos)}.`;
}

/** "1 crédito", "1.000 créditos". */
export function rotuloCreditos(n: number): string {
  return `${n.toLocaleString('pt-BR')} ${n === 1 ? 'crédito' : 'créditos'}`;
}
